import state from './state'

/**
 * Plain ES getters, evaluated on access — no `computed`, no memoisation. Matches AuthorBase.
 * The Vuex `getXxx` prefix is dropped now that these are read as `store.getters.returnLocation`.
 */
export default {
  get returnLocation () {
    return state().returnLocation
  },
  get returnCrudModel () {
    return state().returnCrudModel
  },
  get returnLabel () {
    return state().returnLabel
  },
  get completeLabel () {
    return state().completeLabel
  },
  get attachModelId () {
    return state().attachModelId
  },
  get meta () {
    return state().meta
  }
}
